export function getViewport() {
  return {
    width: window.innerWidth,
    height: window.innerHeight,
  };
}
